var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import qs from "qs";
import { Button, Input } from "@mui/joy";
import { LoaderImage } from "@/utils/loader";
import { useGetCampaignConfigQuery, useSaveCampaignConfigMutation, } from "@/store/api"; // ton apiSlice
import { get_current_language } from "@/components/forms/components/utils";
export default function CampaignConfig() {
    var _this = this;
    var t = useTranslation([
        "Administration",
        "common",
        "Campaign",
        "EmailMan",
    ]).t;
    var navigate = useNavigate();
    var initialized = useRef(false);
    var _a = useState({
        massemailer_campaign_emails_per_run: 500,
        massemailer_tracking_entities_location_type: 1,
        massemailer_tracking_entities_location: "",
        massemailer_email_copy: 1,
        massemailer_campaign_bounce_threshold: 4,
    }), settings = _a[0], setSettings = _a[1];
    var _b = useState({}), Campaign = _b[0], setCampaign = _b[1];
    var _c = useState(""), siteUrl = _c[0], setSiteUrl = _c[1];
    //const fieldsParam = { settings };
    var fieldsParam = {
        settings: {
            massemailer_campaign_emails_per_run: 500,
            massemailer_tracking_entities_location_type: 1,
            massemailer_tracking_entities_location: "",
            massemailer_email_copy: 1,
            massemailer_campaign_bounce_threshold: 4,
        },
    };
    var fields = {
        settings: {
            massemailer_campaign_emails_per_run: 500,
            massemailer_tracking_entities_location_type: 1,
            massemailer_tracking_entities_location: "",
            massemailer_email_copy: 1,
            massemailer_campaign_bounce_threshold: 4,
        },
        config: {},
        passwordsetting: {},
    };
    var queryString = qs.stringify({ lang: get_current_language() || "en_US", fields: fields }, { arrayFormat: "brackets" });
    var _d = useGetCampaignConfigQuery({
        params: queryString,
    }), data = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    var _e = useSaveCampaignConfigMutation(), saveCampaignConfig = _e[0], saving = _e[1].isLoading;
    useEffect(function () {
        if (!initialized.current && (data === null || data === void 0 ? void 0 : data.data)) {
            initFormResponse(data.data);
            initialized.current = true;
        }
    }, [data]);
    /*const initFormResponse = (data: any) => {
      const cfg = data.configs?.settings || {};
      setSettings({
        ...settings,
        ...cfg,
      });
      setCampaign(data.Campaign || {});
      setSiteUrl(data.site_url || "");
    };*/
    var parseNumberOrDefault = function (value, defaultValue) {
        var n = Number(value);
        return Number.isNaN(n) ? defaultValue : n;
    };
    var initFormResponse = function (data) {
        var _a, _b;
        var cfg = ((_a = data.configs) === null || _a === void 0 ? void 0 : _a.settings) || {};
        setSettings({
            massemailer_campaign_emails_per_run: parseNumberOrDefault(cfg.massemailer_campaign_emails_per_run, 500),
            massemailer_tracking_entities_location_type: parseNumberOrDefault(cfg.massemailer_tracking_entities_location_type, 1),
            massemailer_tracking_entities_location: (_b = cfg.massemailer_tracking_entities_location) !== null && _b !== void 0 ? _b : "",
            massemailer_email_copy: parseNumberOrDefault(cfg.massemailer_email_copy, 1),
            massemailer_campaign_bounce_threshold: parseNumberOrDefault(cfg.massemailer_campaign_bounce_threshold, 4),
        });
        setCampaign(data.Campaign || {});
        setSiteUrl(data.site_url || "");
    };
    var _f = useState(false), isLoad = _f[0], setLoad = _f[1];
    var saveConfigs = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoad(true);
                    return [4 /*yield*/, saveCampaignConfig({
                            body: { settings: settings },
                        }).unwrap()];
                case 1:
                    response = _a.sent();
                    console.log("Campaign settings saved", response);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    console.error("Failed to save campaign settings", err_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoad(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /*const setLocation = (locationType: number) => {
      setSettings((prev) => ({
        ...prev,
        massemailer_tracking_entities_location_type: locationType,
        massemailer_tracking_entities_location:
          locationType === 1
            ? Campaign.TRACKING_ENTRIES_LOCATION_DEFAULT_VALUE || ""
            : siteUrl,
      }));
    };*/
    var setLocation = function (locationType) {
        var updatedSettings = __assign(__assign({}, settings), { massemailer_tracking_entities_location_type: locationType });
        if (locationType === 1) {
            updatedSettings.massemailer_tracking_entities_location =
                Campaign.TRACKING_ENTRIES_LOCATION_DEFAULT_VALUE || "";
        }
        else {
            updatedSettings.massemailer_tracking_entities_location = siteUrl;
        }
        setSettings(updatedSettings);
    };
    return (_jsxs("div", __assign({ className: "Campaign overflow-y-auto  bg-[var(--colors-bg-default)] text-[--colors-label]  p-2 space-y-6 m-2 rounded-md" }, { children: [_jsx("h1", __assign({ className: "text-xl font-bold mb-4" }, { children: t("LBL_CAMPAIGN_CONFIG_TITLE", { ns: "Administration" }) })), _jsx(Button, __assign({ onClick: saveConfigs }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), isLoad && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "card mt-4 shadow-md rounded-2xl" }, { children: [_jsx("header", __assign({ className: "card-header bg-gray-100 p-3" }, { children: _jsx("p", __assign({ className: "card-header-title font-semibold" }, { children: t("LBL_OUTBOUND_EMAIL_TITLE", {
                                ns: "EmailMan",
                            }) })) })), _jsxs("div", __assign({ className: "card-content p-4" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [_jsx("label", { children: t("LBL_EMAILS_PER_RUN", {
                                            ns: "EmailMan",
                                        }) }), _jsx(Input, { type: "number", value: settings.massemailer_campaign_emails_per_run || "", onChange: function (e) {
                                            return setSettings(function (prev) { return (__assign(__assign({}, prev), { massemailer_campaign_emails_per_run: Number(e.target.value) })); });
                                        } })] })), _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [_jsx("label", { children: Campaign.LBL_LOCATION_TRACK }), _jsxs("div", { children: [_jsxs("label", { children: [_jsx("input", { type: "radio", name: "location", value: 1, checked: settings.massemailer_tracking_entities_location_type === 1, onChange: function () { return setLocation(1); } }), Campaign.LBL_DEFAULT_LOCATION] }), _jsxs("label", __assign({ className: "ml-4" }, { children: [_jsx("input", { type: "radio", name: "location", value: 2, checked: settings.massemailer_tracking_entities_location_type === 2, onChange: function () { return setLocation(2); } }), t("LBL_CUSTOM_LOCATION", {
                                                        ns: "EmailMan",
                                                    })] }))] })] })), _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [_jsx("div", {}), _jsx(Input, { type: "text", value: settings.massemailer_tracking_entities_location ||
                                            Campaign.TRACKING_ENTRIES_LOCATION_DEFAULT_VALUE ||
                                            "", onChange: function (e) {
                                            return setSettings(function (prev) { return (__assign(__assign({}, prev), { massemailer_tracking_entities_location: e.target.value })); });
                                        } })] })), _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [_jsx("label", { children: Campaign.LBL_CAMP_MESSAGE_COPY }), _jsxs("div", { children: [_jsxs("label", { children: [_jsx("input", { type: "radio", name: "keepcopy", value: 1, checked: settings.massemailer_email_copy === 1, onChange: function () {
                                                            return setSettings(function (prev) { return (__assign(__assign({}, prev), { massemailer_email_copy: 1 })); });
                                                        } }), Campaign.LBL_YES] }), _jsxs("label", __assign({ className: "ml-4" }, { children: [_jsx("input", { type: "radio", name: "keepcopy", value: 0, checked: settings.massemailer_email_copy === 0, onChange: function () {
                                                            return setSettings(function (prev) { return (__assign(__assign({}, prev), { massemailer_email_copy: 0 })); });
                                                        } }), Campaign.LBL_NO] }))] })] })), _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [_jsx("label", { children: Campaign.LBL_BOUNCE_THRESHOLD }), _jsx(Input, { type: "text", value: settings.massemailer_campaign_bounce_threshold || "", onChange: function (e) {
                                            return setSettings(function (prev) { return (__assign(__assign({}, prev), { massemailer_campaign_bounce_threshold: Number(e.target.value) })); });
                                        } })] })), _jsx("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: _jsx("div", { children: _jsx("a", __assign({ href: "#", onClick: function (e) {
                                            e.preventDefault();
                                            navigate("/modules/OutboundEmailAccounts");
                                        } }, { children: Campaign.LBL_OUTBOUND_EMAIL_ACCOUNT_VIEW })) }) }))] }))] }))] })));
}
